export function getVisitorId() {
  try {
    let id = localStorage.getItem("ds_visitor_id");
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("ds_visitor_id", id);
    }
    return id;
  } catch (e) {
    return "anon";
  }
}
